exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navBox[data-v-3d97b7f5] {\n  padding: 0 1.4rem;\n  height: 2.25rem;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n}\n.navBox .navText[data-v-3d97b7f5] {\n  color: #00ab84;\n}\n.navBox .navText[data-v-3d97b7f5]:after {\n  content: \"\";\n  width: 3rem;\n  height: 0.1rem;\n  position: absolute;\n  left: 0;\n  bottom: -0.8rem;\n  background: #73dacf;\n  border-radius: 5rem;\n}\n.top55[data-v-3d97b7f5] {\n  margin-top: 2.75rem;\n}", ""]);

// exports
